var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result.id)?_c('v-main',[_c('AppBanner'),_c('v-container',{attrs:{"fluid":""}},[_c('IndividualTitle',{attrs:{"item":_vm.result}}),_c('AttributeList',{attrs:{"type":"biosample","item":_vm.result}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }